'use strict';

/**
 * VideoStage
 *
 * @author Srdan Turudic <srdan.turudic@namics.com>
 */
T.Module.VideoStage = T.createModule({

	_selectors: {
		video: '.m-video-stage__video',
		toggleSound: '.m-video-stage__sound'
	},
	_stateClasses: {
		videoSoundOn: 'm-video-stage__sound--on'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.$video = this.$ctx.find(this._selectors.video);
		this.$toggleSound = this.$ctx.find(this._selectors.toggleSound);

		this.$toggleSound.click(this.handleVideoSound.bind(this));

		resolve();
	},


	/**
  * Toggle attr muted on click to handle video sound and switch icon
  * @returns {void}
  */
	handleVideoSound: function handleVideoSound() {
		var attr = this.$video.prop('muted');

		this.$video.prop('muted', !attr);
		this.$toggleSound.toggleClass(this._stateClasses.videoSoundOn);
	}
});